import { CssBaseline, ThemeProvider } from '@mui/material';
import { useNavigate, useRoutes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeSettings } from './theme/Theme';
import RTL from './layouts/full/shared/customizer/RTL';
import ScrollToTop from './components/shared/ScrollToTop';
import Spinner from './views/spinner/Spinner';
import createAppRoutes from './routes/Router';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './providers/AuthProvider';
import { useEffect, useState } from 'react';
import { fetchUserDetails, userSelector } from './store/apps/slices/UserSlice';
import { clearAllState, loadState } from './lib/utils';
import { isEmpty } from 'lodash';
import { appSelector, handleInvalidToken } from './store/apps/slices/AppSlice';
import { InactiveAccountDialog, SessionExpiredDialog } from './components/common';
import './assets/styles/main.css';
import { generateToken } from './fcm';
import { LOCAL_STORAGE_KEYS } from './lib/constants';

function App() {
  const { user, isPendingUserDetails } = useSelector(userSelector);
  const { accessDenied } = useSelector(appSelector);
  const navigate = useNavigate();
  const [permission, setPermission] = useState('');

  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);
  const dispatch = useDispatch();
  const fcmToken = localStorage.getItem('fcmToken');
  const isLoggedIn = loadState(LOCAL_STORAGE_KEYS.token);
  const storedUser = loadState(LOCAL_STORAGE_KEYS.user);

  useEffect(() => {
    const requestAndSaveToken = async () => {
      try {
        // Check if notifications are supported
        if (!('Notification' in window)) {
          console.log('This browser does not support notifications');
          return;
        }
        if (!fcmToken) {
          await generateToken();
        }

      } catch (error) {
        console.error('Error in requestAndSaveToken:', error);
      }
    };

    isLoggedIn && requestAndSaveToken();
  }, []);

  useEffect(() => {
    !isEmpty(storedUser) && dispatch(fetchUserDetails(storedUser?.id));
  }, []);


  const handleLogin = () => {
    clearAllState();
    navigate('/auth/login', { replace: true });
    dispatch(handleInvalidToken(false));
  };

  const routing = useRoutes(createAppRoutes(user));

  if (isPendingUserDetails) {
    return <Spinner />;
  }

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <ToastContainer
          position="top-right"
          autoClose={7000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <RTL direction={customizer.activeDir}>
          <CssBaseline />
          <ScrollToTop>{routing}</ScrollToTop>
          <SessionExpiredDialog open={accessDenied} onLogin={handleLogin} />
          <InactiveAccountDialog />
        </RTL>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
